module.exports = __webpack_public_path__ + "img/theBoot.21d337c0.png";